import { EnvironmentBase } from '../../environment.base';

/**
 * environment settings for deployment on dev-slot
 */
export const environment: EnvironmentBase = {
  production: true,
  apiBaseUrl: 'https://pasm-zap-api-dev.pasmapps.de',
  version: '1.7.1',
  app: 'portal',
  env: 'shared/environment.dev.ts',
  appInsights: { instrumentationKey: 'a7771826-8764-4da4-9a44-446a4ba8fe8e' },

  AadClientId: 'b17f848e-5d95-4d42-b630-aab82a0db94a',
  AadScope: 'https://pasmb2cdev.onmicrosoft.com/pasm-zap-api-dev/API.Access',
  AadAuthorityDomain: 'pasmb2cdev.b2clogin.com',
  AadSignupSigninUrl:
    'https://pasmb2cdev.b2clogin.com/pasmb2cdev.onmicrosoft.com/B2C_1A_SIGNIN_ONLY',
  AadPasswordResetUrl:
    'https://pasmb2cdev.b2clogin.com/pasmb2cdev.onmicrosoft.com/B2C_1_PasswordReset',
};
